import Vue from 'vue'
import Router      from 'vue-router'
import HelloWorld  from '@/components/HelloWorld'
import ApplyServer from '@/path/applyServer'
import SubSuccess  from '@/path/subSuccess'
import ApplyList   from '@/path/applyList'
import ApplyDetail from '@/path/applyDetail'
import Submenu     from '@/path/submenu/submenu'
import chatremark     from '@/path/submenu/chatremark'
import Chat     from '@/path/submenu/chat'
import ServicePage from '@/path/servicePage/service'
import RichPage    from '@/path/servicePage/richPage'
import SaleDetail from '@/path/salesReturn/saleDetail' //退货申请详情
import Signature from '@/path/signature/signature' //个人签名
Vue.use(Router)

export default new Router({
  routes: [
//  {
//    path: '/',
//    name: 'HelloWorld',
//    component: HelloWorld
//  },
    {
    	path: '/ApplyServer',
    	name: 'ApplyServer',
    	component: ApplyServer

    },
    {
    	path : '/subSuccess',
    	name : 'SubSuccess',
    	component : SubSuccess
    },
    {
    	path    : '/',
    	name : 'ApplyList',
    	component : ApplyList

    },
    {
    	path : '/applyDetail',
    	name : 'ApplyDetail',
    	component : ApplyDetail
    },
    {
    	path : '/submenu',
    	name : 'Submenu',
    	component : Submenu
    },
    {
    	path : '/service',
    	name : 'Service',
    	component : ServicePage
    },
    {
    	path : '/richPage',
    	name : 'RichPage',
    	component : RichPage
    },
    {
    	path : '/saleDetail',
    	name : 'SaleDetail',
    	component : SaleDetail
    },

    {
    	path : '/chatremark',
    	name : 'chatremark',
    	component : chatremark
    },
    {
    	path : '/chat',
    	name : 'chatremark',
    	component : Chat
    },
		{
    	path : '/signature',
    	name : 'Signature',
    	component : Signature
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js